import React from "react";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import CalendarAside from "../../../components/CalendarAside/CalendarAside";

const Calendar = () => {
   const { width } = useWindowDimensions();
   const isTablet = width < 1000;

   if(!isTablet) {
      return (
         <div className="dashboard__calendar">
            <CalendarAside />
         </div>
      );
   }
   
   return null;
}

export default Calendar; 